import { render, staticRenderFns } from "./ruleGroupList.vue?vue&type=template&id=77d475e6"
import script from "./ruleGroupList.vue?vue&type=script&lang=js"
export * from "./ruleGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports